<template>
  <LineChart :chart-data="configData" :chart-options="options"/>
</template>

<script>
import LineChart from '../../shared/LineChart'

export default {
  name: 'ClientLineChart',
  components: { LineChart },
  props: {
    chartData: {
      type: Object,
      default: () => ({})
    },
    labels: {
      type: Array,
      default: () => ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
    }
  },
  data() {
    return {
      datasetConfig : {
        'Quotes' : {
          label: 'Cotizaciones',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          backgroundColor: 'transparent',
          borderColor: 'rgba(75,192,192,1)',
          borderWidth: 2
        },
        'Orders' :{
          label: 'Ordenes',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          backgroundColor: 'transparent',
          borderColor: '#007bff',
          borderWidth: 2
        },
        'ServiceCalls' : {
          label: 'Llamadas de Servicio',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          backgroundColor: 'transparent',
          borderColor: '#6c757d',
          borderWidth: 2
        },
        'ServiceContracts': {
          label: 'Contratos de Mantenimiento',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          backgroundColor: 'transparent',
          borderColor: '#dc3545',
          borderWidth: 2
        },
        'Invoices': {
          label: 'Facturas',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          backgroundColor: 'transparent',
          borderColor: '#047232',
          borderWidth: 2
        }
        // 'oc': {
        //   label: 'OC Pendientes',
        //   data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        //   backgroundColor: 'transparent',
        //   borderColor: '#ffc107',
        //   borderWidth: 2
        // },
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        // title: {
        //   display: true,
        //   text: 'Gráfico de líneas',
        //   fontSize: 17,
        //   fontColor: '#1d58b7'
        // },
        tooltips: {
          mode: 'index',
          axis: 'y'
        },
        legend: {
          labels: {
            fontSize: 13
          }
        }
      }
    }
  },
  computed: {
    configData () {
      const defaultData = { labels: [...this.labels], datasets: [] }
      if (!this.chartData) return defaultData

      const chartData = JSON.parse(JSON.stringify(this.chartData))

      if (!Object.keys(chartData).length) return defaultData

      defaultData.datasets = Object.entries(chartData).map(([key, value]) => {
        const baseDataset = this.datasetConfig[key]

        if (!baseDataset) {
          const fallback = JSON.parse(JSON.stringify(this.datasetConfig['Orders']))
          fallback.label = 'No definido'
          fallback.data = value
          return fallback
        }

        const clonedDataset = JSON.parse(JSON.stringify(baseDataset))

        clonedDataset.data = value

        return clonedDataset
      })

      return defaultData
    }
  }
}
</script>